// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Vero Software components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Vero Software components
import ClientQuoteCard from "components/ClientQuoteCard";
import ThemedLogo from "components/ThemedLogo";

// Client logos
import SdmLogo from "assets/images/SdmLogo.png";
import TisdelLogo from "assets/images/TisdelLogo.png";
import TrevarrowLogo from "assets/images/TrevarrowLogo.png";
import ShearLogo from "assets/images/shear_enterprises_logo.jpeg";
import SdmLogoDark from "assets/images/SdmLogo-dark.png";
import TisdelLogoDark from "assets/images/TisdelLogo-dark.png";
import TrevarrowLogoDark from "assets/images/TrevarrowLogo-dark.png";
import ShearLogoDark from "assets/images/shear_enterprises_logo-dark.png";


function ClientsAndTestimonials() {
  return (
    <MKBox id="clients" component="section" py={6} sx={{ scrollMarginTop: "120px" }}>
      <Container>

        <MKTypography
          variant="button"
          textTransform="uppercase"
          fontWeight="bold"
          color="text"
          textAlign="center"
          display="block"
          mb={3}
        >
          Trusted by
        </MKTypography>
        <Grid container spacing={3} alignItems="stretch">
          <Grid item xs={12} md={4}>
            <ClientQuoteCard
              name="Holly Ellis"
              review="The guys at Vero Software are great to work with. They got us through our D365 implementation and migration from Quickbooks after multiple failed attempts."
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <ClientQuoteCard
              name="Tom Fath"
              review="Bob has been a great resource for us. He's available whenever we need him to ensure our system is running smoothly. I highly recommend him and his team."
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <ClientQuoteCard
              name="John Tisdel"
              review="We were one of Vero's first clients and we've continued to use them for 25 years. They've guided us through multiple ERP implementations and integrations."
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 6 }} />

        <Grid container spacing={3} justifyContent="center" alignItems="stretch">
          <Grid item xs={6} md={3} lg={2}>
            <MKBox
              bgColor="surface"
              borderRadius="lg"
              shadow="sm"
              p={1.5}
              height="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <ThemedLogo light={SdmLogo} dark={SdmLogoDark} alt="SDM Northcoast" width="100%" />
            </MKBox>
          </Grid>
          <Grid item xs={6} md={3} lg={2}>
            <MKBox
              bgColor="surface"
              borderRadius="lg"
              shadow="sm"
              p={1.5}
              height="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <ThemedLogo light={TisdelLogo} dark={TisdelLogoDark} alt="Tisdel Distributing" width="100%" />
            </MKBox>
          </Grid>
          <Grid item xs={6} md={3} lg={2}>
            <MKBox
              bgColor="surface"
              borderRadius="lg"
              shadow="sm"
              p={1.5}
              height="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <ThemedLogo light={ShearLogo} dark={ShearLogoDark} alt="Shear Enterprises" width="100%" />
            </MKBox>
          </Grid>
          <Grid item xs={6} md={3} lg={2}>
            <MKBox
              bgColor="surface"
              borderRadius="lg"
              shadow="sm"
              p={1.5}
              height="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <ThemedLogo light={TrevarrowLogo} dark={TrevarrowLogoDark} alt="Trevarrow" width="100%" />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ClientsAndTestimonials;
